export default __webpack_public_path__ + "static/media/3.9bdee90e.jpg";